<!-- 维护章信息 -->
<template>
    <el-dialog :title="isedit ? '编辑章' : '新增章'" :visible.sync="dialogVisible" :before-close="handleClose" custom-class="dialogForm" class="measDialog maintainSection" width="670px" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="params" :rules="rules" ref="maintainSection">
                <el-form-item label="章名称" prop="sectionname">
                    <el-input v-model="params.sectionname" placeholder="请输入章名称" maxlength="30" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <span slot="footer" class="dialog-footer">
            <el-button class="cancel" :disabled="loading" @click="handleClose">取消</el-button>
            <el-button type="primary" @click="saveCourseSection" :loading="loading">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {saveCourseSection} from '@/api/measApi/courseManage.js'
export default {
    data() {
        return {
            isedit: false,
            dialogVisible: false,
            params: {
                coursecode: '', // 课程code
                code: '', // 目标code
                sectionname: '' // 章名称
            },
            rules: {
                sectionname: [
                    {required: true, message: '请输入章名称', trigger: ['change', 'blur']}
                ]
            },
            loading: false
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen(coursecode, code, sectionname) {
            this.dialogVisible = true
            this.params.coursecode = coursecode
            if (code) {
                this.isedit = true
                this.params.code = code
                this.params.sectionname = sectionname
            } else {
                this.isedit = false
            }
            this.$nextTick(() => {
                this.$refs.maintainSection.clearValidate()
            })
        },
        handleClose() {
            if (this.loading) {
                this.$message.warning('提交数据中，请稍等')
                return
            }
            this.dialogVisible = false
            this.isedit = false
            this.params.coursecode = ''
            this.params.code = ''
            this.params.sectionname = ''
        },
        saveCourseSection() {
            this.$refs.maintainSection.validate(valid => {
                if (valid) {
                    this.loading = true
                    saveCourseSection(this.params).then(res => {
                        this.loading = false
                        if (res.code === '000') {
                            this.$message.success(res.msg)
                            this.$emit('maintainSectionSuccess')
                            this.handleClose()
                        }
                    })
                } else {
                    this.$message.warning('请完善您的数据')
                }
            })
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .maintainSection {
        .el-dialog.dialogForm {
            height: 216px;
            top: calc((100% - 216px) / 2) !important;
        }
    }
</style>